var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"paging-count-showing"},[_vm._v("\n  Showing "+_vm._s(_vm.dataShowing.from)+" to "+_vm._s(_vm.dataShowing.to)+" of "+_vm._s(_vm.dataShowing.limit)+" entries "+_vm._s(_vm.filteredDataMessage)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }